import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChangepasswordService {

  ApiURL = environment.ApiURL + '/admin';
  public headers_token: HttpHeaders;

  constructor(private http: HttpClient) {
    this.headers_token = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    });
  }

  changepassword(data: any): Observable<any> {
    const body = JSON.stringify(data);
    return this.http.post(this.ApiURL + '/Setting', body, { headers: this.headers_token });
  }

}














